<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Project Code -->
      <b-form-group
        :label="$t('Project Code')"
        label-for="mc-project-code"
      >
        <validation-provider
          #default="{ errors }"
          name="Project Code"
          rules="required"
        >
          <b-form-input
            v-model="item.projectCode"
            :state="errors.length > 0 ? false : null"
            :placeholder="$t('Project Code')"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Project Name -->
      <b-form-group
        :label="$t('Project Name')"
        label-for="mc-project-name"
      >
        <validation-provider
          #default="{ errors }"
          name="Project Name"
          rules="required"
        >
          <b-form-input
            v-model="item.projectName"
            :state="errors.length > 0 ? false : null"
            :placeholder="$t('Project Name')"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Status -->
      <b-form-group
        :label="$t('Status')"
        label-for="mc-status"
      >
        <b-form-checkbox
          id="checkbox-status"
          v-model="item.status"
          name="checkbox-status"
          switch
        >
          <span v-if="item.status">{{ $t('Active') }}</span>
          <span v-if="!item.status">{{ $t('Passive') }}</span>
        </b-form-checkbox>
      </b-form-group>

      <!-- Data check -->
      <template>
        <p><strong class="text-primary">{{ $t('Data Check Warnings') }}</strong></p>

        <b-row>

          <!-- DataCheckSame -->
          <b-col>
            <b-form-group
              :label="$t('Warn if it is same')"
              label-for="mc-dataCheckSame"
            >
              <b-form-checkbox
                id="checkbox-dataCheckSame"
                v-model="item.dataCheckSame"
                name="checkbox-dataCheckSame"
                switch
              >
                <span v-if="item.dataCheckSame">{{ $t('Yes') }}</span>
                <span v-if="!item.dataCheckSame">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- DataCheckMore -->
          <b-col>
            <b-form-group
              :label="$t('Warn if it is more')"
              label-for="mc-dataCheckMore"
            >
              <b-form-checkbox
                id="checkbox-dataCheckMore"
                v-model="item.dataCheckMore"
                name="checkbox-dataCheckMore"
                switch
              >
                <span v-if="item.dataCheckMore">{{ $t('Yes') }}</span>
                <span v-if="!item.dataCheckMore">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- DataCheckLess -->
          <b-col>
            <b-form-group
              :label="$t('Warn if it is less')"
              label-for="mc-dataCheckLess"
            >
              <b-form-checkbox
                id="checkbox-dataCheckLess"
                v-model="item.dataCheckLess"
                name="checkbox-dataCheckLess"
                switch
              >
                <span v-if="item.dataCheckLess">{{ $t('Yes') }}</span>
                <span v-if="!item.dataCheckLess">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

        </b-row>

        <!-- DataCheckEmails -->
        <b-row v-if="item.dataCheckSame || item.dataCheckMore || item.dataCheckLess">
          <b-col>
            <b-form-group
              :label="$t('Send warnings to these e-mail accounts')"
              label-for="dataCheckEmails"
            >
              <b-form-textarea
                v-model="item.dataCheckEmails"
                :placeholder="$t('Email Address List... (separate by ;)')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormCheckbox, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    BRow,
    BCol,
    BFormTextarea,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        projectCode: null,
        projectName: null,
        status: false,
        dataCheckSame: false,
        dataCheckMore: false,
        dataCheckLess: false,
        dataCheckEmails: null,
      },
      required,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.item.id) {
            useJwt.axiosIns.patch('project', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('project', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
